import { ZonedDateTimeFactory } from '@csp/csp-common-date-util';
import { PatientActivityClient, PatientLastClientActivity } from '@csp/csp-common-model';

import { LastClientActivityV1, UserV1 } from '@csp/dmdp-api-user-dto';

const toPatientLastClientActivity = (
  lastClientActivity: Record<string, LastClientActivityV1>,
): PatientLastClientActivity => {
  const lastActiveApp = ZonedDateTimeFactory.fromZonedDateTimeString(
    lastClientActivity[PatientActivityClient.APP]?.activeAtUTC,
    lastClientActivity[PatientActivityClient.APP]?.timezone,
  );
  const lastActiveWeb = ZonedDateTimeFactory.fromZonedDateTimeString(
    lastClientActivity[PatientActivityClient.WEB]?.activeAtUTC,
    lastClientActivity[PatientActivityClient.WEB]?.timezone,
  );

  const { lastActivityTimestamp, lastActivityClient } =
    (lastActiveApp?.unixTimeMillis || 0) >= (lastActiveWeb?.unixTimeMillis || 0)
      ? {
          lastActivityTimestamp: lastActiveApp,
          lastActivityClient: PatientActivityClient.APP,
        }
      : {
          lastActivityTimestamp: lastActiveWeb,
          lastActivityClient: PatientActivityClient.WEB,
        };

  const web = lastClientActivity[PatientActivityClient.WEB] &&
    lastActiveWeb && {
      activeAt: lastActiveWeb,
      browser: lastClientActivity[PatientActivityClient.WEB].browser,
    };

  const app = lastClientActivity.APP &&
    lastActiveApp && {
      activeAt: lastActiveApp,
      operatingSystem: lastClientActivity[PatientActivityClient.APP]?.operatingSystem,
      version: lastClientActivity[PatientActivityClient.APP]?.version,
    };

  return {
    lastActivityTimestamp,
    lastActivityClient,
    web,
    app,
  };
};

const from = (userV1: UserV1): PatientLastClientActivity => {
  const lastClientActivity = userV1.lastClientActivity;

  return lastClientActivity ? toPatientLastClientActivity(lastClientActivity) : PatientLastClientActivity.empty;
};

export const PatientLastClientActivityMapper = {
  from,
};
